import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Crown, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, formatError } from "@/lib/api";

export function VipSearch({ onAdded }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState(null);
  const active = q.trim().length >= 2;

  useEffect(() => {
    setResults(null);
    if (!active) return undefined;
    const t = setTimeout(() => {
      api.get("/admin/customers/search", { params: { q: q.trim() } }).then((r) => setResults(r.data)).catch((e) => toast.error(formatError(e)));
    }, 250);
    return () => clearTimeout(t);
  }, [q, active]);

  const promote = async (c) => {
    try {
      await api.post("/admin/vips", { user_id: c.user_id });
      toast.success(`${c.name} agora é Cliente VIP`);
      setQ("");
      onAdded();
    } catch (e) {
      toast.error(formatError(e));
    }
  };

  return (
    <div className="rounded-md border border-amber-200 bg-amber-50/60 p-5" data-testid="vip-search-box">
      <p className="font-display font-bold">Adicionar Cliente VIP</p>
      <p className="mb-3 text-sm text-slate-600">Busque pelo nome ou e-mail de um cliente que já tenha conta no site.</p>
      <div className="relative">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Nome ou e-mail do cliente" className="h-11 bg-white pl-9" data-testid="vip-search-input" />
      </div>
      {active && results && (
        <ul className="mt-3 divide-y divide-slate-100 rounded-md border border-slate-200 bg-white" data-testid="vip-search-results">
          {results.map((c) => (
            <li key={c.user_id} className="flex flex-wrap items-center justify-between gap-3 p-3" data-testid={`vip-result-${c.user_id}`}>
              <div className="min-w-0"><p className="truncate font-semibold">{c.name}</p><p className="truncate text-xs text-slate-500">{c.email}</p></div>
              {c.role === "vip"
                ? <span className="rounded-full bg-amber-100 px-3 py-1 text-xs font-bold text-amber-800" data-testid={`vip-already-${c.user_id}`}>Já é VIP</span>
                : <Button size="sm" onClick={() => promote(c)} className="rounded-full bg-amber-500 text-slate-900 hover:bg-amber-400" data-testid={`btn-promote-vip-${c.user_id}`}><Crown className="h-4 w-4" /> Tornar VIP</Button>}
            </li>
          ))}
          {results.length === 0 && <li className="p-3 text-sm text-slate-500" data-testid="vip-search-empty">Nenhuma conta de cliente encontrada. Peça ao cliente para criar a conta em Entrar → Criar conta.</li>}
        </ul>
      )}
    </div>
  );
}
